import { Suspense, lazy } from 'react';
import type { PartialRouteObject } from 'react-router';
import LoadingScreen from './components/LoadingScreen';
import { GuardClient, AuthClient, GuardAdmin, GuardCashier, ProtectGuard } from './guards';
import CashierDepositDetail from './pages/Cashier/CashierDepositDetail';
import AcademyPage from './pages/AcademyPage';
import AcademyDetailPage from './pages/AcademyDetailPage';
import AcademyHomePage from './pages/AcademyHomePage';
import AcademyHomeDetailPage from './pages/AcademyHomeDetailPage';
import NewsHomePage from './pages/NewsHomePage';
import PromotionalVideoWatch from './pages/PromotionalVideoWatch';
import GuardGuest from './guards/GuardGuest';


export const Loadable = (Component: any) => (props: any) => (
  <Suspense fallback={<LoadingScreen />}>
    <Component {...props} />
  </Suspense>
);

const Landing = Loadable(lazy(() => import('./pages/Landing')))
/* const Login = Loadable(lazy(() => import('./pages/Login'))) */
//const LogoutSecure = Loadable(lazy(() => import('./pages/LogoutSecure')))
const LogoutAnimation = Loadable(lazy(() => import('./pages/LogoutAnimation')))
const UserDashboard = Loadable(lazy(() => import('./pages/UserDashboardNew')))
const TestingHour = Loadable(lazy(() => import('./pages/TestingHour')))
const BeClient = Loadable(lazy(() => import('./pages/BeClient')))
//const ProfilePage = Loadable(lazy(() => import('./pages/OLDProfilePage')))
const ChooseCashierPage = Loadable(lazy(() => import('./pages/ChooseCashier')))
const UserTransferDetail = Loadable(lazy(() => import('./pages/UserTransferDetail')))
//const AcademyPage = Loadable(lazy(() => import('./pages/AcademyPage')))
//const AcademyDetailPage = Loadable(lazy(() => import('./pages/AcademyDetailPage')))
//const AcademyHomePage = Loadable(lazy(() => import('./pages/AcademyHomePage')))
const AboutUsPage = Loadable(lazy(() => import('./pages/AboutUsPage')))
const ReferenceCashierClient = Loadable(lazy(() => import('./pages/ReferenceCashierClient')))
const RegisterCashier = Loadable(lazy(() => import('./pages/RegisterCashier')))
//const AcademyHomeDetailPage = Loadable(lazy(() => import('./pages/AcademyHomeDetailPage')))
const Recover = Loadable(lazy(() => import('./pages/Recover')))
const MyAccounts = Loadable(lazy(() => import('./pages/MyAccounts')))
const MyAccountEdit = Loadable(lazy(() => import('./pages/MyAccountEdit')))
const HelpPage = Loadable(lazy(() => import('./pages/HelpPage')))
//const DepositNew = Loadable(lazy(() => import('./pages/DepositNew')))
const Transfer = Loadable(lazy(() => import('./pages/Transfer')))
const CashierFiatPrice = Loadable(lazy(() => import('./pages/CashierFiatPrice')))
const BlogDetailPage = Loadable(lazy(() => import('./pages/BlogDetailPage')))
const NotFound = Loadable(lazy(() => import('./pages/NotFound')))
const VerifyAccountPage = Loadable(lazy(() => import('./pages/VerifiyAccountPage')))
const SecurityPage = Loadable(lazy(() => import('./pages/SecurityPage')))
const PolicyPage = Loadable(lazy(() => import('./pages/PolicyPage')))
const TermsPage = Loadable(lazy(() => import('./pages/Terms')))
const TransferFastView = Loadable(lazy(() => import('./pages/TransferFastView')))
const AdminDashboard = Loadable(lazy(() => import('./pages/Admin/AdminDashboard')))
const AdminFiat = Loadable(lazy(() => import('./pages/Admin/Fiat')))
const AdminFiatEdit = Loadable(lazy(() => import('./pages/Admin/FiatEdit')))
const AdminCoinsRequestList = Loadable(lazy(() => import('./pages/Admin/AdminCoinsRequestList')))
const AdminCoinsRequestDetail = Loadable(lazy(() => import('./pages/Admin/AdminCoinsRequestDetail')))
const AdminCoinsAccountsList = Loadable(lazy(() => import('./pages/Admin/AdminCoinsAccountsList')))
const AdminProcessors = Loadable(lazy(() => import('./pages/Admin/ProcessorsList')))
const AdminProcessorsreate = Loadable(lazy(() => import('./pages/Admin/ProcessorsCreate')))
const AdminProcessorsEdit = Loadable(lazy(() => import('./pages/Admin/ProcessorsEdit')))
const AdminDeposit = Loadable(lazy(() => import('./pages/Admin/Deposit')))
const AdminDepositDetail = Loadable(lazy(() => import('./pages/Admin/DepositDetail')))
const AdminDepositTime = Loadable(lazy(() => import('./pages/Admin/DepositTime')))
const AdminUserList = Loadable(lazy(() => import('./pages/Admin/UserList')))
const AdminRolePage = Loadable(lazy(() => import('./pages/Admin/RolePage')))
const UserDetail = Loadable(lazy(() => import('./pages/Admin/UserDetail')))
const AdminUserVerification = Loadable(lazy(() => import('./pages/Admin/AdminUserVerificationList')))
const AdminBlog = Loadable(lazy(() => import('./pages/Admin/Blog/AdminBlog')))
const AdminBlogSave = Loadable(lazy(() => import('./pages/Admin/Blog/AdminBlogSave')))
const AdminOpinions = Loadable(lazy(() => import('./pages/Admin/AdminOpinions')))
const AdminProfit = Loadable(lazy(() => import('./pages/Admin/AdminProfit')))
const AdminCashier = Loadable(lazy(() => import('./pages/Admin/AdminCashier')))
const AdminHouseCoins = Loadable(lazy(() => import('./pages/Admin/AdminHouseCoins')))
const AdminVideo = Loadable(lazy(() => import('./pages/Admin/Blog/AdminVideo')))
const AdminVideoPromotional = Loadable(lazy(() => import('./pages/Admin/Blog/AdminVideoPromotional')))
const AdminWeltrade = Loadable(lazy(() => import('./pages/Admin/AdminWeltrade')))
/* const AdminUserVerificationDetail = Loadable(lazy(() => import('./pages/Admin/AdminUserVerificationDetail'))) */
const AdminDepositBolivares = Loadable(lazy(() => import('./pages/Admin/AdminDepositBolivares')))

const CashierRechargeCoins = Loadable(lazy(() => import('./pages/Cashier/CashierRechargeCoins')))
const CashierRechargeCoinsForm = Loadable(lazy(() => import('./pages/Cashier/CashierRechargeCoinsForm')))
const CashierConfig = Loadable(lazy(() => import('./pages/Cashier/CashierConfig')))
const CashierRechargeCoinsDetail = Loadable(lazy(() => import('./pages/Cashier/CashierRechargeCoinsDetail')))
const CashierRanges = Loadable(lazy(() => import('./pages/Cashier/CashierRanges')))
const CashierClients = Loadable(lazy(() => import('./pages/Cashier/CashierClients')))
const CashierSchedule = Loadable(lazy(() => import('./pages/Cashier/CashierSchedule')))
const CashierCalculator = Loadable(lazy(() => import('./pages/Cashier/CashierCalculator')))
/* const CashierApodo = Loadable(lazy(() => import('./pages/Cashier/CashierApodo')))
 */const CashierGetMoney = Loadable(lazy(() => import('./pages/Cashier/CashierGetMoney')))
const CashierGetMoneySaveEdit = Loadable(lazy(() => import('./pages/Cashier/CashierGetMoneySaveEdit')))
//const CashierProfile = Loadable(lazy(() => import('./pages/Cashier/CashierProfile')))
const CashierDasboard = Loadable(lazy(() => import('./pages/Cashier/CashierDashboard')))
const CashierProcessor = Loadable(lazy(() => import('./pages/Cashier/CashierProcessor')))
const CashierCoinsDisplay = Loadable(lazy(() => import('./pages/Cashier/CashierCoinsDisplay')))
 

const routes: PartialRouteObject[] = [
  
/*   {
    path: '/login',
    children: [
      {

        element: (
          <AuthClient><Login /></AuthClient>
        )
      },
    ]
  }, */
  {
    path: '/',
    element: (<Landing />)
  },

  {
    path: '/testinghour',
    element: (<TestingHour />)
  },
  {
    path: '/:apodo',
    element: (<Landing />)
  },
  {
    path: '/promotional/:videoslug',
    element: (<PromotionalVideoWatch />)
  },  

  // =============================================================
  // ROUTES CLIENT  
  // =============================================================
  {
    path: '/inicio',
    element: (<GuardClient><UserDashboard /></GuardClient>)
  },
  {
    path: '/salir',
    element: (<LogoutAnimation />)
  },
  {
    path: '/logout-secure',
    element: (<LogoutAnimation />)
  },
/*   {
    path: '/logout-secure',
    element: (<GuardClient><LogoutSecure /></GuardClient>)
  },   */
  {
    path: '/inicio/:tab',
    element: (<GuardClient><UserDashboard /></GuardClient>)
  },
  {
    path: '/unirse/',
    element: (<AuthClient><BeClient /></AuthClient>)
  },  
  {
    path: '/registro-cajero/',
    element: (<AuthClient><RegisterCashier /></AuthClient>)
  },
  {
    path: '/registro-usuario',
    element: (<AuthClient><RegisterCashier /></AuthClient>)
  },  
  {
    path: '/registro-usuario/',
    element: (<AuthClient><RegisterCashier /></AuthClient>)
  },  
/*   {
    path: '/perfil',
    element: (<GuardClient><ProfilePage /></GuardClient>)
  }, */
  {
    path: '/elegir-cajero',
    element: (<GuardClient><ChooseCashierPage /></GuardClient>)
  },  
/*   {
    path: '/perfil/:tab',
    element: (<GuardClient><ProfilePage /></GuardClient>)
  }, */
  {
    path: '/transferencia',
    element: (<GuardClient><UserTransferDetail /></GuardClient>)
  },
  {
    path: '/transferencia/:transferId',
    element: (<GuardClient><UserTransferDetail /></GuardClient>)
  },
/*   {
    path: '/perfil/chat',
    element: (<GuardClient><ProfilePage /></GuardClient>)
  },
  {
    path: '/perfil/notificaciones',
    element: (<GuardClient><ProfilePage /></GuardClient>)
  }, */
  {
    path: '/aprender',
    element: (<ProtectGuard><AcademyPage /></ProtectGuard>)
  },
  {
    path: '/aprender/detalle/:id',
    element: (<ProtectGuard><AcademyDetailPage /></ProtectGuard>)
  },
  {
    path: '/academia',
    element: (<AcademyHomePage />)
  },
  {
    path: '/quienes-somos',
    element: (<AboutUsPage />)
  },  
  {
    path: '/referido/:link',
    element: (<ReferenceCashierClient />)
  }, 
  {
    path: '/academia/detalle/:id',
    element: (<AcademyHomeDetailPage />)
  },
  {
    path: '/recover',
    element: (<Recover />)
  },
  {
    path: '/mis-cuentas',
    element: (<GuardClient><MyAccounts /></GuardClient>)
  },
  {
    path: '/mis-cuentas/:proccessorId',
    element: (<GuardClient><MyAccounts /></GuardClient>)
  },  
  {
    path: '/mis-cuentas/editar',
    element: (<GuardClient><MyAccountEdit /></GuardClient>)
  },
  {
    path: '/ayuda',
    element: (<GuardClient><HelpPage /></GuardClient>)
  },
  {
    path: '/transferir/',
    element: (<GuardClient><Transfer /></GuardClient>)
  },  
/*   {
    path: '/transferirviejo/',
    element: (<GuardClient><DepositNew /></GuardClient>)
  },   */
  /*{
    path: '/deposita/detalle/:id',
    element: (<GuardClient><DepositDetailUser /></GuardClient>)
  }, */
  {
    path: '/verificar-cuenta/:id',
    element: (<VerifyAccountPage />)
  },
  {
    path: '/seguridad',
    element: (<GuardClient><SecurityPage /></GuardClient>)
  },
  {
    path: '/noticia/:slug',
    element: (<GuardClient><BlogDetailPage /></GuardClient>)
  },  
  {
    path: '/videos/:id?',
    element: (<NewsHomePage />)
  }, 
  {
    path: '/blog',
    element: (<NewsHomePage />)
  },
  {
    path: '/blog/:slug',
    element: (<BlogDetailPage />)
  },  
  {
    path: '*',
    element: (<NotFound />)
  },

   {/* <Routes>
  <Route path="/" element={<Landing />} />

  <Route path="/login" element={<Login />} />

  <Route path="/inicio" element={<UserDashboard />} />

  <Route path="/register" element={<Register />} />

  <Route path="/perfil" element={<ProfilePage />} />
  
  <Route path="/perfil/retiros" element={<ProfilePage />} />

  <Route path="/perfil/depositos" element={<ProfilePage />} />
 
  <Route path="/perfil/detalle/retiro/:withdrawId" element={<ProfileWithdrawDetail />} />

  <Route path="/perfil/chat" element={<ProfilePage />} />
  
  <Route path="/perfil/notificaciones" element={<ProfilePage />} />

  <Route path="/academia" element={<AcademyPage />} />

  <Route path="/aprender" element={<AcademyHomePage />} />


  <Route path="/recover" element={<Recover />} />

  <Route path="/mis-cuentas" element={<MyAccounts />} />

  <Route path="/mis-cuentas/editar" element={<MyAccountEdit />} />

  <Route path="/atencion-al-cliente" element={<CustomerService />} />

  <Route path="/depositos" element={<DepositPage />} />

  <Route path="/verificar-cuenta/:id" element={<VerifyAccountPage />} />

  <Route path="/retiros" element={<WithdrawPage />} />
  
  <Route path="/seguridad" element={<SecurityPage />} />

  <Route path="/blog" element={<BlogPage />} />

</Routes> */},
  
  // =================================================
  // ROUTES CAJERO 
  // =================================================
  {
    path: '/cashier',
    element: (<GuardCashier><CashierDasboard /></GuardCashier>)
  },

  {
    path: '/cashier/:tab',
    element: (<GuardCashier><CashierDasboard /></GuardCashier>)
  },

  {
    path: '/cashier/config',
    element: (<GuardCashier><CashierConfig /></GuardCashier>)
  },  
  {
    path: '/cashier/movimientos',
    element: (<GuardCashier><CashierCoinsDisplay /></GuardCashier>)
  },  
  {
    path: '/cashier/recargar-coins',
    element: (<GuardCashier><CashierRechargeCoins/></GuardCashier>)
  },
  {
    path: '/cashier/recargar-coins/formulario',
    element: (<GuardCashier><CashierRechargeCoinsForm/></GuardCashier>)
  },
  {
    path: '/cashier/transfer-coins/:id',
    element: (<GuardCashier><CashierRechargeCoinsDetail/></GuardCashier>)
  },
  {
    path: '/cashier/clientes',
    element: (<GuardCashier><CashierClients /></GuardCashier>)
  }, 
  {
    path: '/cashier/horario',
    element: (<GuardCashier><CashierSchedule /></GuardCashier>)
  },    
  {
    path: '/cashier/calculadora',
    element: (<GuardCashier><CashierCalculator /></GuardCashier>)
  },    
/*   {
    path: '/cashier/apodo',
    element: (<GuardCashier><CashierApodo /></GuardCashier>)
  },       */
  {
    path: '/cashier/procesadores',
    element: (<GuardCashier><CashierProcessor /></GuardCashier>)
  },
  {
    path: '/cashier/dolar',
    element: (<GuardCashier><CashierFiatPrice /></GuardCashier>)
  },
    
  {
    path: '/cashier/rangos',
    element: (<GuardCashier><CashierRanges /></GuardCashier>)
  },  
  {
    path: '/cashier/recibir-dinero',
    element: (<GuardCashier><CashierGetMoney /></GuardCashier>)
  },    
  {
    path: '/cashier/recibir-dinero/guardar',
    element: (<GuardCashier><CashierGetMoneySaveEdit /></GuardCashier>)
  },    
      
  {
    path: '/cashier/transferencia/:transferId',
    element: (<GuardCashier><CashierDepositDetail /></GuardCashier>)
  },      
  
  // =================================================
  // ROUTES ADMIN 
  // =================================================
  {
    path: '/admin',
    element: (<GuardAdmin><AdminDashboard /></GuardAdmin>)
  },
  {
    path: '/admin/cashier',
    element: (<GuardAdmin><AdminCashier /></GuardAdmin>)
  },  
  {
    path: '/admin/videos',
    element: (<GuardAdmin><AdminVideo /></GuardAdmin>)
  },
  {
    path: '/admin/videos/promocional',
    element: (<GuardAdmin><AdminVideoPromotional /></GuardAdmin>)
  },  
  {
    path: '/admin/weltrade',
    element: (<GuardAdmin><AdminWeltrade /></GuardAdmin>)
  },    
  {
    path: '/admin/fiat',
    element: (<GuardAdmin><AdminFiat /></GuardAdmin>)
  },
  {
    path: '/admin/fiat/editar',
    element: (<GuardAdmin><AdminFiatEdit /></GuardAdmin>)
  },
  {
    path: '/admin/solicitud-coins',
    element: (<GuardAdmin><AdminCoinsRequestList /></GuardAdmin>)
  },
  {
    path: '/admin/solicitud-coins/:id',
    element: (<GuardAdmin><AdminCoinsRequestDetail /></GuardAdmin>)
  },
  {
    path: '/admin/cuenta-pago-coins/',
    element: (<GuardAdmin><AdminCoinsAccountsList /></GuardAdmin>)
  },
  {
    path: '/admin/procesadores',
    element: (<GuardAdmin><AdminProcessors /></GuardAdmin>)
  },
  {
    path: '/admin/procesadores/crear',
    element: (<GuardAdmin><AdminProcessorsreate /></GuardAdmin>)
  },
  {
    path: '/admin/procesadores/editar',
    element: (<GuardAdmin><AdminProcessorsEdit /></GuardAdmin>)
  },
  {
    path: '/admin/depositos',
    element: (<GuardAdmin><AdminDeposit /></GuardAdmin>)
  },
  {
    path: '/admin/depositos-bolivares',
    element: (<GuardAdmin><AdminDepositBolivares /></GuardAdmin>)
  },  
/*   {
    path: '/admin/depositos/detalle',
    element: (<GuardAdmin><AdminDepositDetail /></GuardAdmin>)
  }, */
  {
    path: '/admin/transferencia/:transferId',
    element: (<GuardAdmin><AdminDepositDetail /></GuardAdmin>)
  },
  {
    path: '/admin/depositos/detalle/:transferId',
    element: (<GuardAdmin><AdminDepositDetail /></GuardAdmin>)
  },
  {
    path: '/admin/depositos/tiempo',
    element: (<GuardAdmin><AdminDepositTime /></GuardAdmin>)
  },
  {
    path: '/admin/usuario/lista',
    element: (<GuardAdmin><AdminUserList /></GuardAdmin>)
  },
  {
    path: '/admin/roles',
    element: (<GuardAdmin><AdminRolePage /></GuardAdmin>)
  },  
  {
    path: '/usuario/:id',
    element: (<ProtectGuard><UserDetail /></ProtectGuard>)
  },  
  {
    path: '/usuario/:id/:tabUrl',
    element: (<ProtectGuard><UserDetail /></ProtectGuard>)
  },  
 
  {
    path: '/admin/verificaciones',
    element: (<GuardAdmin><AdminUserVerification /></GuardAdmin>)
  },  
  /*{
    path: '/admin/verificaciones/:id',
    element: (<GuardAdmin><LayoutAdmin><AdminUserVerificationDetail /></LayoutAdmin></GuardAdmin>)
  },*/
  {
    path: '/admin/transferencias/opiniones',
    element: (<GuardAdmin><AdminOpinions /></GuardAdmin>)
  }, 
  {
    path: '/admin/blog',
    element: (<GuardAdmin><AdminBlog /></GuardAdmin>)
  },
  {
    path: '/admin/coins',
    element: (<GuardAdmin><AdminHouseCoins /></GuardAdmin>)
  },  
  {
    path: '/admin/blog/guardar',
    element: (<GuardAdmin><AdminBlogSave /></GuardAdmin>)
  },
  {
    path: '/admin/fee-de-ganancia',
    element: (<GuardAdmin><AdminProfit /></GuardAdmin>)
  },  
  {
    path: '/politica-de-privacidad',
    element: (<PolicyPage />)
  },
  {
    path: '/terminos-y-condiciones',
    element: (<TermsPage />)
  },


  {
    path: '/transferencia/:transferId/weltrade',
    element: (<GuardGuest><TransferFastView /></GuardGuest>)
  },  
  
  {/* 
    
    <Route path="/admin" element={<AdminDashboard />} />

    <Route path="/admin/fiat" element={<AdminFiat />} />

    <Route path="/admin/fiat/editar" element={<AdminFiatEdit />} />

    <Route path="/admin/procesadores" element={<AdminProcessors />} />

    <Route path="/admin/procesadores/crear" element={<AdminProcessorsreate />} />

    <Route path="/admin/procesadores/editar" element={<AdminProcessorsEdit />} />

    <Route path="/admin/procesadores/fiat" element={<AdminProcessorsFiat />} />

    <Route path="/admin/cuentas-bancarias" element={<AdminAccountBank />} />

    <Route path="/admin/cuentas-bancarias/guardar" element={<AdminAccountBankSave />} />

    <Route path="/admin/depositos" element={<AdminDeposit />} />
    
    <Route path="/admin/depositos/detalle" element={<AdminDepositDetail />} />

    <Route path="/admin/depositos/detalle/:depositId" element={<AdminDepositDetail />} />

    <Route path="/admin/depositos/tiempo" element={<AdminDepositTime />} />

    <Route path="/admin/retiros" element={<AdminWithdrawList />} />

    <Route path="/admin/retiros/detalle/:withdrawId" element={<AdminWithdrawDetail />} />

    <Route path="/admin/usuario/lista" element={<AdminUserList />} />

    <Route path="/admin/usuario/detalle/:userId" element={<AdminUserDetail />} />

    <Route path="/admin/blog" element={<AdminBlog />} />

    <Route path="/admin/blog/guardar" element={<AdminBlogSave />} />

    <Route path="/PolicyPage" element={<PolicyPage />} />

    <Route path="/rules" element={<Rules />} />

*/},
 
]



export default routes;